import api from 'ApiConfig';

const feeService = {
  getCourseBatchInfo: async (selectedBranch) => {
    return api.post('/fee/get-course-batch', { selectedBranch });
  },
  getStudentDetails: async (data, selectedBranch) => {
    return api.post('/fee/get-student-detail-to-pay', {
      ...data,
      selectedBranch,
    });
  },
  makePayment: async (data) => {
    return api.post('/fee/make-payment', data);
  },
  getStudentPaymentDetails: async (studentId) => {
    console.log(studentId, 'studentId');
    return api.post('/fee/get-students-fee-details', { studentId });
  },
  updateInstallmentDate: async ({ installmentId, newDueDate, amount }) => {
    return api.post('/fee/installments/update-due-date', {
      newDueDate,
      installmentId,
      amount,
    });
  },
  addInstallment: async (data) => {
    return api.post('/fee/add-new-installmet', data);
  },
  // getStudents: async (data) => {
  //   return api.post('/fee/get-student-detail-to-pay', data);
  // },
  getStudentFeeDetails: async (studentId) => {
    return api.post('/fee/get-student-fee-details', { studentId });
  },
  deleteInstallment: async (installmentId) => {
    return api.post('/fee/delete-installment', { installmentId });
  },
  getBranch: async () => {
    return api.post('/fee/get-branch');
  },
  getAllCourses: async (selectedBranch) => {
    return api.post('/fee/get-all-course', { selectedBranch });
  },
  getBatchStructuresByCourse: async (courseId) =>
    api.post(`/fee/get-batch-structures-by-course/${courseId}`),

  getBatchesByBatchStructure: (structureId, selectedBranch) =>
    api.post('/fee/get-batches-by-structure', {
      batchStructureId: structureId,
      selectedBranch,
    }),
};
export default feeService;
